import SectionHeading from "./SectionHeading";
import { newReleases } from "@/mocks/shows";

export default function NewReleases() {
  return (
    <section id="new" className="scroll-mt-24 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="新剧上线"
          title="本月新上线，附更新时间与进度"
          description="新剧上线后大多按固定星期连载。下面的进度条表示已放出集数占全剧的比例，方便你判断是现在开追还是等养肥。"
        />

        <div className="mt-9 flex flex-col gap-4">
          {newReleases.map((show) => {
            const done = Number(show.progress.replace(/[^0-9]/g, "")) || 0;
            const total = Number(show.total.replace(/[^0-9]/g, "")) || done;
            const percent = Math.min(100, Math.round((done / total) * 100));

            return (
              <article
                key={show.id}
                className="reveal flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 md:flex-row md:p-5"
              >
                <div className="h-40 w-full shrink-0 overflow-hidden rounded-md bg-background-200 md:h-36 md:w-28">
                  <img
                    src={show.cover}
                    alt={`${show.title}新剧封面`}
                    className="h-full w-full object-cover"
                  />
                </div>

                <div className="flex flex-1 flex-col">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-semibold text-foreground-950">
                      新剧
                    </span>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {show.title}
                    </h3>
                    <span className="text-xs text-foreground-500">{show.genre}</span>
                  </div>

                  <p className="mt-2 text-sm leading-7 text-foreground-600">{show.summary}</p>

                  <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-calendar-schedule-line text-secondary-500"></i>
                      {show.updateDay}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-play-list-2-line text-secondary-500"></i>
                      {show.progress}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-file-list-3-line text-secondary-500"></i>
                      {show.total}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-time-line text-secondary-500"></i>
                      首播 {show.premierDate}
                    </span>
                  </div>

                  <div className="mt-4 flex items-center gap-3">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${percent}%` }}
                      ></div>
                    </div>
                    <span className="whitespace-nowrap text-xs font-medium text-primary-700">
                      {percent}%
                    </span>
                  </div>
                </div>

                <div className="flex items-center md:flex-col md:justify-center">
                  <a
                    href="#hot"
                    className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 md:w-auto"
                  >
                    <i className="ri-play-circle-line text-base"></i>
                    去观看
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}